import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 15h12l-12 -12h12v6h-12v6l6 6v-6","key":"svg-0"}]]

/**
 * IconBrandFramer
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtZnJhbWVyIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik02IDE1aDEybC0xMiAtMTJoMTJ2NmgtMTJ2Nmw2IDZ2LTYiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/brand-framer
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandFramer = createReactComponent('outline', 'brand-framer', 'BrandFramer', __iconNode);

export default IconBrandFramer;